import React from 'react'
import { useTranslation } from 'react-i18next'

import { ChartDescription } from '../ChartDescription/ChartDescription'

/**
 * One caption under the adoption line stating the cohort it is measured
 * against, agreed in the 2026-09-07 review. Nothing to say when the scope has
 * no resolved cohort size.
 */
export const TrackedSetDisclaimer: React.FC<{ cohortSize: number | null }> = ({ cohortSize }) => {
  const { t } = useTranslation()
  if (cohortSize === null) return null
  return <ChartDescription sx={{ mt: 1 }}>{t('market-analytics:tracked_set_disclaimer', { count: cohortSize })}</ChartDescription>
}
